import styled, {css} from "styled-components"
import {Hr} from "@irati/ui/src/Layout"
import {Row} from "@irati/ui/src/ColumnRow"
import {Body} from "@irati/ui/src/Typography"

interface LogoProps {
  logoUrl: string
}

export const TableRow = styled(Row)`
  ${({theme}) => css`
    padding: ${theme.spacing.two} 0;
    display: flex;
    align-items: center;
  `}
`

export const DealRow = styled(Row)`
  display: flex;
  padding: 12px 0 0;
  ${({theme}) => css`
    padding: ${theme.spacing.oneAndHalf} 0;
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: 16px 0;
    `}
  `}
`

export const TypeIcon = styled.div`
  ${({theme}) => css`
    padding: 0 ${theme.spacing.half};
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: 0 12px;
    `}
  `}
`

export const BrandLogo = styled.div<LogoProps>`
  ${({theme, logoUrl}) => css`
    display: none;
    width: 40px;
    height: 40px;
    border-radius: 52px;
    overflow: hidden;
    background: ${logoUrl ? `url(${logoUrl}) center/cover` : theme.colors.greys.light};
    flex-shrink: 0;
    box-shadow: ${theme.shadows.low};
    ${theme.mediaQueries.minWidthMedia.tablet`
      display: block;
    `}
  `}
`

export const OtherRedemptionsIconWrapper = styled.div`
  ${({theme}) => css`
    display: none;
    border-radius: 52px;
    width: 40px;
    height: 40px;
    background-position: center;
    background-size: contain;
    background-color: ${theme.colors.greys.light};
    box-shadow: ${theme.shadows.low};
    ${theme.mediaQueries.minWidthMedia.tablet`
      display: flex;
      align-items: center;
      justify-content: center;
    `}
  `}
`

export const StyledHr = styled(Hr)`
  border-top: 1px solid ${({theme}) => theme.colors.greys.black};
`

export const Header = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 80%;
  text-align: left;
`

export const DealHeaderWrapper = styled(Body)`
  display: flex;
  flex: 1;
`
